import { cn } from '../../utils/cn'
import { NavPanel } from './NavPanel'
import { NavRail } from './NavRail'

/** Widths of the two sidebar states, straight from the design. */
export const SIDEBAR_WIDTH = { collapsed: 90, expanded: 213 } as const

type SidebarProps = {
  activeId: string
  expanded: boolean
  onToggle: () => void
  onSelect?: (id: string) => void
  onExpand?: () => void
}

/**
 * Animates between the icon rail and the labelled panel. Both states stay mounted in the
 * same grid cell so the container can animate its width while they cross-fade; the
 * inactive one is hidden from pointers and assistive tech.
 */
export const Sidebar = ({ activeId, expanded, onToggle, onSelect, onExpand }: SidebarProps) => (
  <div
    className={cn(
      'grid shrink-0 transition-[width] duration-300 ease-in-out motion-reduce:transition-none',
      expanded
  ? 'w-[213px] overflow-visible'
  : 'w-[90px] overflow-hidden',
    )}
  >
    <div
      inert={expanded}
      className={cn(
        'col-start-1 row-start-1 transition-opacity duration-200 ease-in-out motion-reduce:transition-none',
       expanded
  ? 'invisible pointer-events-none opacity-0'
  : 'visible pointer-events-auto opacity-100 delay-150',
      )}
    >
      <NavRail activeId={activeId} onSelect={onSelect} onToggle={onToggle} onExpand={onExpand} />
    </div>

    <div
      inert={!expanded}
      className={cn(
        'col-start-1 row-start-1 transition-opacity duration-200 ease-in-out motion-reduce:transition-none',
        expanded
  ? 'visible pointer-events-auto opacity-100 delay-150'
  : 'invisible pointer-events-none opacity-0',
      )}
    >
      <NavPanel activeId={activeId} onSelect={onSelect} onToggle={onToggle} />
    </div>
  </div>
)
